(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/breed-alphabet-filter"],{

/***/ "./src/assets/js/breed-alphabet-filter.js":
/*!************************************************!*\
  !*** ./src/assets/js/breed-alphabet-filter.js ***!
  \************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var BreedAlphabetFilter = /*#__PURE__*/function (_HTMLElement) {
  function BreedAlphabetFilter() {
    var _this;
    _classCallCheck(this, BreedAlphabetFilter);
    _this = _callSuper(this, BreedAlphabetFilter);
    _this.swiper = null;
    _this.navigationPrev = null;
    _this.navigationNext = null;
    _this.articlesData = [];
    _this.articlesMap = new Map();
    _this.activeFilters = {
      characteristics: [],
      weight: null,
      fur_type: null,
      colors: [],
      letter: null
    };
    _this.filterLabels = {
      weight: 'Größe',
      fur_type: 'Felltyp',
      characteristics: 'Charaktereigenschaften',
      colors: 'Farbe'
    };
    _this.filteredWrappers = [];
    _this.paginationContainer = null;
    _this.paginationPrev = null;
    _this.paginationNext = null;
    _this.paginationNumbers = null;
    _this.paginationStatus = null;
    _this.currentPage = 1;
    _this.itemsPerPage = 9;
    _this.totalPages = 1;
    _this.onPaginationPrevClick = _this.onPaginationPrevClick.bind(_this);
    _this.onPaginationNextClick = _this.onPaginationNextClick.bind(_this);
    _this.onPaginationNumbersClick = _this.onPaginationNumbersClick.bind(_this);
    return _this;
  }
  _inherits(BreedAlphabetFilter, _HTMLElement);
  return _createClass(BreedAlphabetFilter, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      setTimeout(function () {
        return _this2.init();
      }, 10);
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      // Init filter modal trigger
      this.filterTrigger = this.querySelector('[data-breed-filter-trigger]');
      if (this.filterTrigger) {
        this.filterTrigger.addEventListener('click', function () {
          return _this3.openFilterModal();
        });
      }

      // Init filters from JSON data
      this.initFilters();

      // Init filter action buttons
      this.initFilterActions();

      // Init alphabet filter
      this.initAlphabetFilter();

      // Init pagination controls
      this.setupPagination();

      // Load filters from URL on page load
      this.loadFiltersFromURL();

      // Initial data rendering
      this.collectActiveFilters();
      this.filterArticles();
      this.renderActiveFilters();
      var checkSwiper = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
          console.log('Swiper.  call');
          _this3.initSwiper();
          clearInterval(checkSwiper);
        }
      }, 100);
    }
  }, {
    key: "openFilterModal",
    value: function openFilterModal() {
      var modal = document.getElementById('breed-filter-modal');
      if (modal && modal.open) {
        modal.open();
      }
    }
  }, {
    key: "initFilters",
    value: function initFilters() {
      var _this4 = this;
      var dataScript = document.getElementById('breed-articles-data');
      if (!dataScript) return;
      try {
        var data = JSON.parse(dataScript.textContent);
        this.articlesData = data.articles || [];
        this.articlesMap = new Map();

        // Collect unique values
        var characteristics = new Set();
        var weights = new Set();
        var furTypes = new Set();
        var colors = new Map(); // Map to store color name and hex

        this.articlesData.forEach(function (article) {
          if (article !== null && article !== void 0 && article.handle) {
            _this4.articlesMap.set(article.handle, article);
          }

          // Characteristics
          if (Array.isArray(article.characteristics)) {
            article.characteristics.forEach(function (_char) {
              if (_char && _char.trim()) characteristics.add(_char.trim());
            });
          }

          // Weight
          if (article.weight && article.weight.trim()) {
            weights.add(article.weight.trim());
          }

          // Fur type
          if (article.fur_type && article.fur_type.trim()) {
            furTypes.add(article.fur_type.trim());
          }

          // Color (format: "Name,#hex")
          if (article.color && article.color.trim()) {
            var _article$color$split$ = article.color.split(',').map(function (s) {
                return s.trim();
              }),
              _article$color$split$2 = _slicedToArray(_article$color$split$, 2),
              colorName = _article$color$split$2[0],
              colorHex = _article$color$split$2[1];
            if (colorName && colorHex) {
              colors.set(colorName, colorHex);
            }
          }
        });

        // Render filters
        this.renderCharacteristics(Array.from(characteristics));
        this.renderWeights(Array.from(weights));
        this.renderFurTypes(Array.from(furTypes));
        this.renderColors(colors);

        // Attach event listeners after rendering
        this.attachFilterEventListeners();
      } catch (error) {
        console.error('Error parsing breed articles data:', error);
      }
    }
  }, {
    key: "renderCharacteristics",
    value: function renderCharacteristics(items) {
      var _this5 = this;
      var container = document.querySelector('[data-filter-characteristics]');
      if (!container) return;
      container.innerHTML = items.map(function (item, index) {
        return "\n      <label class=\"filter-characteristics-label\">\n        <input\n          type=\"checkbox\"\n          id=\"char-".concat(index, "\"\n          name=\"characteristics[]\"\n          value=\"").concat(_this5.escapeHtml(item), "\"\n          class=\"tw-peer filter-characteristics-input\"\n        >\n        <span class=\"filter-characteristics-span\">\n          ").concat(_this5.escapeHtml(item), "\n        </span>\n      </label>\n    ");
      }).join('');
    }
  }, {
    key: "renderWeights",
    value: function renderWeights(items) {
      var _this6 = this;
      var container = document.querySelector('[data-filter-weights]');
      if (!container) return;
      container.innerHTML = items.map(function (item, index) {
        return "\n      <label class=\"filter-radio-label\">\n        <input\n          type=\"radio\"\n          id=\"size-".concat(index, "\"\n          name=\"size\"\n          value=\"").concat(_this6.escapeHtml(item), "\"\n          class=\"tw-sr-only tw-hidden\"\n        >\n        <span class=\"weight-radio-indicator filter-radio-indicator\">\n          <svg class=\"tw-opacity-0 tw-transition-opacity\" xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\">\n            <circle cx=\"6\" cy=\"6\" r=\"6\" fill=\"#E1E1FE\"/>\n          </svg>\n        </span>\n        <span class=\"filter-radio-text\">\n          ").concat(_this6.escapeHtml(item), "\n        </span>\n      </label>\n    ");
      }).join('');
    }
  }, {
    key: "renderFurTypes",
    value: function renderFurTypes(items) {
      var _this7 = this;
      var container = document.querySelector('[data-filter-fur-types]');
      if (!container) return;
      container.innerHTML = items.map(function (item, index) {
        return "\n      <label class=\"filter-radio-label\">\n        <input\n          type=\"radio\"\n          id=\"fur-".concat(index, "\"\n          name=\"fur_type\"\n          value=\"").concat(_this7.escapeHtml(item), "\"\n          class=\"tw-sr-only tw-hidden\"\n        >\n        <span class=\"fur-radio-indicator filter-radio-indicator\">\n          <svg class=\"tw-opacity-0 tw-transition-opacity\" xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\">\n          <circle cx=\"6\" cy=\"6\" r=\"6\" fill=\"#E1E1FE\"/>\n          </svg>\n        </span>\n        <span class=\"filter-radio-text\">\n          ").concat(_this7.escapeHtml(item), "\n        </span>\n      </label>\n    ");
      }).join('');
    }
  }, {
    key: "renderColors",
    value: function renderColors(colorsMap) {
      var _this8 = this;
      var container = document.querySelector('[data-filter-colors]');
      if (!container) return;
      var colorsArray = Array.from(colorsMap.entries());
      container.innerHTML = colorsArray.map(function (_ref, index) {
        var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          hex = _ref2[1];
        return "\n      <label class=\"filter-color-label\">\n        <input\n          type=\"checkbox\"\n          id=\"color-".concat(index, "\"\n          name=\"colors[]\"\n          value=\"").concat(_this8.escapeHtml(name), "\"\n          class=\"tw-hidden\"\n        >\n        <span\n          class=\"color-checkbox-indicator filter-color-indicator\"\n          style=\"background-color: ").concat(_this8.escapeHtml(hex), "; box-shadow: inset 0 0 0 1px white; border-width: 1px;\"\n        ></span>\n        <span class=\"filter-color-text\">\n          ").concat(_this8.escapeHtml(name), "\n        </span>\n      </label>\n    ");
      }).join('');
    }
  }, {
    key: "escapeHtml",
    value: function escapeHtml(text) {
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }, {
    key: "attachFilterEventListeners",
    value: function attachFilterEventListeners() {
      var _this9 = this;
      // Characteristics checkboxes
      var characteristicsInputs = document.querySelectorAll('[name="characteristics[]"]');
      characteristicsInputs.forEach(function (input) {
        var label = input.closest('label');
        if (label) {
          label.addEventListener('click', function (e) {
            e.preventDefault();
            input.checked = !input.checked;
            _this9.onFilterChange();
          });
        }
      });

      // Weight radio buttons
      var weightInputs = document.querySelectorAll('[name="size"]');
      weightInputs.forEach(function (input) {
        var label = input.closest('label');
        if (label) {
          label.addEventListener('click', function (e) {
            e.preventDefault();

            // Toggle behavior: if already checked, uncheck it
            if (input.checked) {
              input.checked = false;
              var _indicator = input.parentElement.querySelector('.weight-radio-indicator svg');
              if (_indicator) {
                _indicator.classList.remove('tw-opacity-100');
                _indicator.classList.add('tw-opacity-0');
              }
              _this9.onFilterChange();
              return;
            }

            // Uncheck all and hide all indicators
            weightInputs.forEach(function (radio) {
              radio.checked = false;
              var indicator = radio.parentElement.querySelector('.weight-radio-indicator svg');
              if (indicator) {
                indicator.classList.remove('tw-opacity-100');
                indicator.classList.add('tw-opacity-0');
              }
            });

            // Check current and show indicator
            input.checked = true;
            var indicator = input.parentElement.querySelector('.weight-radio-indicator svg');
            if (indicator) {
              indicator.classList.remove('tw-opacity-0');
              indicator.classList.add('tw-opacity-100');
            }
            _this9.onFilterChange();
          });
        }
      });

      // Fur type radio buttons
      var furInputs = document.querySelectorAll('[name="fur_type"]');
      furInputs.forEach(function (input) {
        var label = input.closest('label');
        if (label) {
          label.addEventListener('click', function (e) {
            e.preventDefault();

            // Toggle behavior: if already checked, uncheck it
            if (input.checked) {
              input.checked = false;
              var _indicator2 = input.parentElement.querySelector('.fur-radio-indicator svg');
              if (_indicator2) {
                _indicator2.classList.remove('tw-opacity-100');
                _indicator2.classList.add('tw-opacity-0');
              }
              _this9.onFilterChange();
              return;
            }

            // Uncheck all and hide all indicators
            furInputs.forEach(function (radio) {
              radio.checked = false;
              var indicator = radio.parentElement.querySelector('.fur-radio-indicator svg');
              if (indicator) {
                indicator.classList.remove('tw-opacity-100');
                indicator.classList.add('tw-opacity-0');
              }
            });

            // Check current and show indicator
            input.checked = true;
            var indicator = input.parentElement.querySelector('.fur-radio-indicator svg');
            if (indicator) {
              indicator.classList.remove('tw-opacity-0');
              indicator.classList.add('tw-opacity-100');
            }
            _this9.onFilterChange();
          });
        }
      });

      // Color checkboxes
      var colorInputs = document.querySelectorAll('[name="colors[]"]');
      colorInputs.forEach(function (input) {
        var label = input.closest('label');
        if (label) {
          label.addEventListener('click', function (e) {
            e.preventDefault();
            input.checked = !input.checked;

            // Toggle border on color indicator
            var indicator = input.parentElement.querySelector('.color-checkbox-indicator');
            if (indicator) {
              if (input.checked) {
                indicator.classList.remove('tw-border-transparent');
                indicator.classList.add('tw-border-accent');
              } else {
                indicator.classList.remove('tw-border-accent');
                indicator.classList.add('tw-border-transparent');
              }
            }
            _this9.onFilterChange();
          });
        }
      });
    }
  }, {
    key: "initAlphabetFilter",
    value: function initAlphabetFilter() {
      var _this0 = this;
      var letterInputs = document.querySelectorAll('.breed-alphabet-radio');
      letterInputs.forEach(function (input) {
        var label = input.nextElementSibling;
        if (label) {
          label.addEventListener('click', function (e) {
            e.preventDefault();
            var clickedLetter = input.getAttribute('data-letter');

            // Toggle behavior: if already checked, uncheck it
            if (input.checked) {
              input.checked = false;
              label.classList.remove('active_letter');
              _this0.activeFilters.letter = null;
            } else {
              // Uncheck all letters
              letterInputs.forEach(function (radio) {
                radio.checked = false;
                var radioLabel = radio.nextElementSibling;
                if (radioLabel) {
                  radioLabel.classList.remove('active_letter');
                }
              });

              // Check current letter
              input.checked = true;
              label.classList.add('active_letter');
              _this0.activeFilters.letter = clickedLetter;
            }
            _this0.onFilterChange();
          });
        }
      });
    }
  }, {
    key: "onFilterChange",
    value: function onFilterChange() {
      // Real-time filter application
      this.collectActiveFilters();
      this.currentPage = 1;
      this.filterArticles();
      this.renderActiveFilters();
      this.updateURL();
    }
  }, {
    key: "initFilterActions",
    value: function initFilterActions() {
      var _this1 = this;
      var closeBtn = document.querySelector('[data-close-modal]');
      var resetBtn = document.querySelector('[data-reset-filters]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          return _this1.closeFilterModal();
        });
      }
      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          return _this1.resetFilters();
        });
      }
    }
  }, {
    key: "collectActiveFilters",
    value: function collectActiveFilters() {
      // Collect characteristics
      var characteristics = [];
      document.querySelectorAll('[name="characteristics[]"]:checked').forEach(function (input) {
        characteristics.push(input.value);
      });

      // Collect weight
      var weightInput = document.querySelector('[name="size"]:checked');
      var weight = weightInput ? weightInput.value : null;

      // Collect fur type
      var furInput = document.querySelector('[name="fur_type"]:checked');
      var fur_type = furInput ? furInput.value : null;

      // Collect colors
      var colors = [];
      document.querySelectorAll('[name="colors[]"]:checked').forEach(function (input) {
        colors.push(input.value);
      });

      // Collect letter (already set in this.activeFilters.letter by initAlphabetFilter)
      var letter = this.activeFilters.letter;
      this.activeFilters = {
        characteristics: characteristics,
        weight: weight,
        fur_type: fur_type,
        colors: colors,
        letter: letter
      };
    }
  }, {
    key: "filterArticles",
    value: function filterArticles() {
      var _this10 = this;
      var articleWrappers = this.querySelectorAll('.breed-article-wrapper');
      var noResultsEl = this.querySelector('[data-no-results]');
      this.filteredWrappers = [];
      articleWrappers.forEach(function (wrapper) {
        var handle = wrapper.getAttribute('data-breed-handle');
        var article = _this10.articlesMap.get(handle);
        if (!article) {
          wrapper.classList.add('tw-hidden');
          wrapper.dataset.matchesFilters = 'false';
          return;
        }
        var matchesFilters = _this10.articleMatchesFilters(article, wrapper);
        if (matchesFilters) {
          wrapper.dataset.matchesFilters = 'true';
          wrapper.classList.remove('tw-hidden');
          _this10.filteredWrappers.push(wrapper);
        } else {
          wrapper.dataset.matchesFilters = 'false';
          wrapper.classList.add('tw-hidden');
        }
      });
      var totalMatches = this.filteredWrappers.length;
      if (totalMatches === 0) {
        noResultsEl === null || noResultsEl === void 0 || noResultsEl.classList.remove('tw-hidden');
      } else {
        noResultsEl === null || noResultsEl === void 0 || noResultsEl.classList.add('tw-hidden');
      }
      this.updatePagination(totalMatches);
      this.applyPagination();
      return totalMatches;
    }
  }, {
    key: "articleMatchesFilters",
    value: function articleMatchesFilters(article, wrapper) {
      var _article$weight, _article$fur_type;
      var _this$activeFilters = this.activeFilters,
        characteristics = _this$activeFilters.characteristics,
        weight = _this$activeFilters.weight,
        fur_type = _this$activeFilters.fur_type,
        colors = _this$activeFilters.colors,
        letter = _this$activeFilters.letter;

      // Check letter first (from data-first-letter on wrapper)
      if (letter) {
        var _wrapper$querySelecto;
        var articleLetter = wrapper === null || wrapper === void 0 || (_wrapper$querySelecto = wrapper.querySelector('[data-first-letter]')) === null || _wrapper$querySelecto === void 0 ? void 0 : _wrapper$querySelecto.getAttribute('data-first-letter');
        if (!articleLetter || articleLetter.toUpperCase() !== letter.toUpperCase()) {
          return false;
        }
      }

      // If no other filters selected, show all (that match letter if set)
      if (characteristics.length === 0 && !weight && !fur_type && colors.length === 0) {
        return true;
      }

      // Check characteristics (OR logic within category)
      if (characteristics.length > 0) {
        var articleChars = Array.isArray(article.characteristics) ? article.characteristics.map(function (c) {
          return c.trim();
        }) : [];
        var hasMatchingChar = characteristics.some(function (filter) {
          return articleChars.includes(filter);
        });
        if (!hasMatchingChar) return false;
      }

      // Check weight (exact match)
      if (weight && ((_article$weight = article.weight) === null || _article$weight === void 0 ? void 0 : _article$weight.trim()) !== weight) {
        return false;
      }

      // Check fur type (exact match)
      if (fur_type && ((_article$fur_type = article.fur_type) === null || _article$fur_type === void 0 ? void 0 : _article$fur_type.trim()) !== fur_type) {
        return false;
      }

      // Check colors (OR logic within category)
      if (colors.length > 0) {
        var _article$color;
        var articleColor = ((_article$color = article.color) === null || _article$color === void 0 || (_article$color = _article$color.split(',')[0]) === null || _article$color === void 0 ? void 0 : _article$color.trim()) || '';
        var hasMatchingColor = colors.includes(articleColor);
        if (!hasMatchingColor) return false;
      }
      return true;
    }
  }, {
    key: "renderActiveFilters",
    value: function renderActiveFilters() {
      var _this11 = this;
      var container = this.querySelector('[data-active-filters]');
      if (!container) return;
      var chips = [];

      // Add letter chip
      if (this.activeFilters.letter) {
        chips.push(this.createFilterChip('letter', this.activeFilters.letter, 'Buchstabe'));
      }

      // Add weight chip
      if (this.activeFilters.weight) {
        chips.push(this.createFilterChip('weight', this.activeFilters.weight, 'Größe'));
      }

      // Add fur type chip
      if (this.activeFilters.fur_type) {
        chips.push(this.createFilterChip('fur_type', this.activeFilters.fur_type, 'Felltyp'));
      }

      // Add characteristics chips
      this.activeFilters.characteristics.forEach(function (_char2) {
        chips.push(_this11.createFilterChip('characteristics', _char2, null));
      });

      // Add color chips
      this.activeFilters.colors.forEach(function (color) {
        chips.push(_this11.createFilterChip('colors', color, 'Farbe'));
      });
      container.innerHTML = chips.join('');

      // Attach remove handlers
      container.querySelectorAll('[data-remove-filter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var filterType = btn.getAttribute('data-filter-type');
          var filterValue = btn.getAttribute('data-filter-value');
          _this11.removeFilter(filterType, filterValue);
        });
      });

      // Show/hide active filters container
      var containerWrapper = this.querySelector('[data-active-filters-container]');
      if (chips.length > 0) {
        containerWrapper === null || containerWrapper === void 0 || containerWrapper.classList.remove('tw-hidden');
      } else {
        containerWrapper === null || containerWrapper === void 0 || containerWrapper.classList.add('tw-hidden');
      }
    }
  }, {
    key: "setupPagination",
    value: function setupPagination() {
      this.paginationContainer = this.querySelector('[data-pagination]');
      if (!this.paginationContainer) return;
      var perPageAttr = parseInt(this.paginationContainer.getAttribute('data-items-per-page'), 10);
      if (!Number.isNaN(perPageAttr) && perPageAttr > 0) {
        this.itemsPerPage = perPageAttr;
      }
      this.paginationPrev = this.paginationContainer.querySelector('[data-pagination-prev]');
      this.paginationNext = this.paginationContainer.querySelector('[data-pagination-next]');
      this.paginationNumbers = this.paginationContainer.querySelector('[data-pagination-numbers]');
      this.paginationStatus = this.paginationContainer.querySelector('[data-pagination-status]');
      if (this.paginationPrev) {
        this.paginationPrev.addEventListener('click', this.onPaginationPrevClick);
      }
      if (this.paginationNext) {
        this.paginationNext.addEventListener('click', this.onPaginationNextClick);
      }
      if (this.paginationNumbers) {
        this.paginationNumbers.addEventListener('click', this.onPaginationNumbersClick);
      }
    }
  }, {
    key: "updatePagination",
    value: function updatePagination(totalMatches) {
      this.totalPages = Math.max(1, Math.ceil(totalMatches / this.itemsPerPage));
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }
      if (!this.paginationContainer) return;
      if (totalMatches > this.itemsPerPage) {
        this.paginationContainer.classList.remove('tw-hidden');
      } else {
        this.paginationContainer.classList.add('tw-hidden');
      }
      this.syncPaginationUI();
    }
  }, {
    key: "syncPaginationUI",
    value: function syncPaginationUI() {
      if (!this.paginationContainer) return;
      this.paginationContainer.setAttribute('data-current-page', String(this.currentPage));
      this.paginationContainer.setAttribute('data-total-pages', String(this.totalPages));
      this.renderPaginationNumbers();
      this.updatePaginationStatus();
      this.updatePaginationControlsState();
    }
  }, {
    key: "renderPaginationNumbers",
    value: function renderPaginationNumbers() {
      if (!this.paginationNumbers) return;
      if (this.totalPages <= 1) {
        this.paginationNumbers.innerHTML = '';
        return;
      }
      var buttons = [];
      for (var page = 1; page <= this.totalPages; page += 1) {
        var isActive = page === this.currentPage;
        var baseClasses = ['breed-pagination__page', 'tw-flex', 'tw-items-center', 'tw-justify-center', 'tw-w-10', 'tw-h-10', 'tw-rounded-full', 'tw-border', 'tw-border-grey', 'tw-text-font14', 'tw-font-montserrrat', 'tw-font-semibold', 'tw-text-dark2', 'tw-transition-all', 'hover:tw-border-dark2'];
        if (isActive) {
          baseClasses.push('tw-bg-dark', 'tw-border-dark', 'tw-text-white');
        } else {
          baseClasses.push('tw-bg-transparent');
        }
        var attributes = ['type="button"', "class=\"".concat(baseClasses.join(' '), "\""), "data-pagination-page=\"".concat(page, "\"")];
        if (isActive) {
          attributes.push('aria-current="page"');
        }
        buttons.push("<button ".concat(attributes.join(' '), ">").concat(page, "</button>"));
      }
      this.paginationNumbers.innerHTML = buttons.join('');
    }
  }, {
    key: "updatePaginationStatus",
    value: function updatePaginationStatus() {
      if (!this.paginationStatus) return;
      if (this.totalPages <= 1) {
        this.paginationStatus.textContent = 'Seite 1 von 1';
        return;
      }
      this.paginationStatus.textContent = "Seite ".concat(this.currentPage, " von ").concat(this.totalPages);
    }
  }, {
    key: "updatePaginationControlsState",
    value: function updatePaginationControlsState() {
      if (this.paginationPrev) {
        var isPrevDisabled = this.currentPage <= 1 || this.totalPages <= 1;
        this.paginationPrev.disabled = isPrevDisabled;
        this.paginationPrev.setAttribute('aria-disabled', isPrevDisabled ? 'true' : 'false');
      }
      if (this.paginationNext) {
        var isNextDisabled = this.currentPage >= this.totalPages || this.totalPages <= 1;
        this.paginationNext.disabled = isNextDisabled;
        this.paginationNext.setAttribute('aria-disabled', isNextDisabled ? 'true' : 'false');
      }
    }
  }, {
    key: "applyPagination",
    value: function applyPagination() {
      if (this.filteredWrappers.length === 0) return;
      var startIndex = (this.currentPage - 1) * this.itemsPerPage;
      var endIndex = startIndex + this.itemsPerPage;
      this.filteredWrappers.forEach(function (wrapper, index) {
        if (index >= startIndex && index < endIndex) {
          wrapper.classList.remove('tw-hidden');
        } else {
          wrapper.classList.add('tw-hidden');
        }
      });
    }
  }, {
    key: "goToPage",
    value: function goToPage(page) {
      if (!this.paginationContainer) return;
      var targetPage = Math.min(Math.max(page, 1), this.totalPages);
      if (targetPage === this.currentPage) return;
      this.currentPage = targetPage;
      this.applyPagination();
      this.syncPaginationUI();
      this.updateURL();
    }
  }, {
    key: "onPaginationPrevClick",
    value: function onPaginationPrevClick(event) {
      event.preventDefault();
      if (this.currentPage <= 1) return;
      this.goToPage(this.currentPage - 1);
    }
  }, {
    key: "onPaginationNextClick",
    value: function onPaginationNextClick(event) {
      event.preventDefault();
      if (this.currentPage >= this.totalPages) return;
      this.goToPage(this.currentPage + 1);
    }
  }, {
    key: "onPaginationNumbersClick",
    value: function onPaginationNumbersClick(event) {
      var button = event.target.closest('[data-pagination-page]');
      if (!button) return;
      var page = parseInt(button.getAttribute('data-pagination-page'), 10);
      if (Number.isNaN(page)) return;
      this.goToPage(page);
    }
  }, {
    key: "createFilterChip",
    value: function createFilterChip(type, value, label) {
      var displayText = label ? "".concat(label, ": ").concat(value) : value;
      var safeDisplay = this.escapeHtml(displayText);
      return "\n      <div class=\"filter-chip\">\n        <span>".concat(safeDisplay, "</span>\n      </div>\n    ");
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(type, value) {
      if (type === 'letter') {
        // Uncheck letter radio
        var input = document.querySelector(".breed-alphabet-radio[data-letter=\"".concat(value, "\"]"));
        if (input) {
          input.checked = false;
          var label = input.nextElementSibling;
          if (label) {
            label.classList.remove('active_letter');
          }
        }
        this.activeFilters.letter = null;
      } else if (type === 'weight') {
        // Uncheck weight radio
        var _input = document.querySelector("[name=\"size\"][value=\"".concat(value, "\"]"));
        if (_input) {
          _input.checked = false;
          var indicator = _input.parentElement.querySelector('.weight-radio-indicator svg');
          if (indicator) {
            indicator.classList.remove('tw-opacity-100');
            indicator.classList.add('tw-opacity-0');
          }
        }
      } else if (type === 'fur_type') {
        // Uncheck fur type radio
        var _input2 = document.querySelector("[name=\"fur_type\"][value=\"".concat(value, "\"]"));
        if (_input2) {
          _input2.checked = false;
          var _indicator3 = _input2.parentElement.querySelector('.fur-radio-indicator svg');
          if (_indicator3) {
            _indicator3.classList.remove('tw-opacity-100');
            _indicator3.classList.add('tw-opacity-0');
          }
        }
      } else if (type === 'characteristics') {
        // Uncheck characteristic checkbox
        var _input3 = document.querySelector("[name=\"characteristics[]\"][value=\"".concat(value, "\"]"));
        if (_input3) {
          _input3.checked = false;
        }
      } else if (type === 'colors') {
        // Uncheck color checkbox
        var _input4 = document.querySelector("[name=\"colors[]\"][value=\"".concat(value, "\"]"));
        if (_input4) {
          _input4.checked = false;
          var _indicator4 = _input4.parentElement.querySelector('.color-checkbox-indicator');
          if (_indicator4) {
            _indicator4.classList.remove('tw-border-accent');
            _indicator4.classList.add('tw-border-transparent');
          }
        }
      }
      this.onFilterChange();
    }
  }, {
    key: "resetFilters",
    value: function resetFilters() {
      // Uncheck all letters
      document.querySelectorAll('.breed-alphabet-radio').forEach(function (input) {
        input.checked = false;
        var label = input.nextElementSibling;
        if (label) {
          label.classList.remove('active_letter');
        }
      });

      // Uncheck all characteristics
      document.querySelectorAll('[name="characteristics[]"]').forEach(function (input) {
        input.checked = false;
      });

      // Uncheck weight
      document.querySelectorAll('[name="size"]').forEach(function (input) {
        input.checked = false;
        var indicator = input.parentElement.querySelector('.weight-radio-indicator svg');
        if (indicator) {
          indicator.classList.remove('tw-opacity-100');
          indicator.classList.add('tw-opacity-0');
        }
      });

      // Uncheck fur type
      document.querySelectorAll('[name="fur_type"]').forEach(function (input) {
        input.checked = false;
        var indicator = input.parentElement.querySelector('.fur-radio-indicator svg');
        if (indicator) {
          indicator.classList.remove('tw-opacity-100');
          indicator.classList.add('tw-opacity-0');
        }
      });

      // Uncheck colors
      document.querySelectorAll('[name="colors[]"]').forEach(function (input) {
        input.checked = false;
        var indicator = input.parentElement.querySelector('.color-checkbox-indicator');
        if (indicator) {
          indicator.classList.remove('tw-border-accent');
          indicator.classList.add('tw-border-transparent');
        }
      });

      // Reset active filters
      this.activeFilters = {
        characteristics: [],
        weight: null,
        fur_type: null,
        colors: [],
        letter: null
      };
      this.currentPage = 1;

      // Update URL and show all articles
      this.updateURL();
      this.filterArticles();
      this.renderActiveFilters();
      this.closeFilterModal();
    }
  }, {
    key: "closeFilterModal",
    value: function closeFilterModal() {
      var modal = document.getElementById('breed-filter-modal');
      if (modal && modal.close) {
        modal.close();
      }
    }

    // URL Parameter Management
  }, {
    key: "updateURL",
    value: function updateURL() {
      var url = new URL(window.location);
      var params = new URLSearchParams();

      // Add letter
      if (this.activeFilters.letter) {
        params.set('letter', this.activeFilters.letter);
      }

      // Add characteristics
      if (this.activeFilters.characteristics.length > 0) {
        params.set('characteristics', this.activeFilters.characteristics.join(','));
      }

      // Add weight
      if (this.activeFilters.weight) {
        params.set('weight', this.activeFilters.weight);
      }

      // Add fur type
      if (this.activeFilters.fur_type) {
        params.set('fur_type', this.activeFilters.fur_type);
      }

      // Add colors
      if (this.activeFilters.colors.length > 0) {
        params.set('colors', this.activeFilters.colors.join(','));
      }
      if (this.currentPage > 1) {
        params.set('page', this.currentPage);
      }

      // Update URL without page reload
      var newUrl = params.toString() ? "".concat(url.pathname, "?").concat(params.toString()) : url.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, {
    key: "loadFiltersFromURL",
    value: function loadFiltersFromURL() {
      var params = new URLSearchParams(window.location.search);

      // Load letter
      var letter = params.get('letter');
      if (letter) {
        var input = document.querySelector(".breed-alphabet-radio[data-letter=\"".concat(letter, "\"]"));
        if (input) {
          input.checked = true;
          var label = input.nextElementSibling;
          if (label) {
            label.classList.add('active_letter');
          }
          this.activeFilters.letter = letter;
        }
      }

      // Load characteristics
      var characteristics = params.get('characteristics');
      if (characteristics) {
        characteristics.split(',').forEach(function (_char3) {
          var input = document.querySelector("[name=\"characteristics[]\"][value=\"".concat(_char3, "\"]"));
          if (input) {
            input.checked = true;
          }
        });
      }

      // Load weight
      var weight = params.get('weight');
      if (weight) {
        var _input5 = document.querySelector("[name=\"size\"][value=\"".concat(weight, "\"]"));
        if (_input5) {
          _input5.checked = true;
          var indicator = _input5.parentElement.querySelector('.weight-radio-indicator svg');
          if (indicator) {
            indicator.classList.remove('tw-opacity-0');
            indicator.classList.add('tw-opacity-100');
          }
        }
      }

      // Load fur type
      var furType = params.get('fur_type');
      if (furType) {
        var _input6 = document.querySelector("[name=\"fur_type\"][value=\"".concat(furType, "\"]"));
        if (_input6) {
          _input6.checked = true;
          var _indicator5 = _input6.parentElement.querySelector('.fur-radio-indicator svg');
          if (_indicator5) {
            _indicator5.classList.remove('tw-opacity-0');
            _indicator5.classList.add('tw-opacity-100');
          }
        }
      }

      // Load colors
      var colors = params.get('colors');
      if (colors) {
        colors.split(',').forEach(function (color) {
          var input = document.querySelector("[name=\"colors[]\"][value=\"".concat(color, "\"]"));
          if (input) {
            input.checked = true;
            var _indicator6 = input.parentElement.querySelector('.color-checkbox-indicator');
            if (_indicator6) {
              _indicator6.classList.remove('tw-border-transparent');
              _indicator6.classList.add('tw-border-accent');
            }
          }
        });
      }
      var pageParam = parseInt(params.get('page'), 10);
      if (!Number.isNaN(pageParam) && pageParam > 0) {
        this.currentPage = pageParam;
      }

      // Apply filters if any were loaded from URL
      if (letter || characteristics || weight || furType || colors) {
        this.collectActiveFilters();
        this.filterArticles();
        this.renderActiveFilters();
      }
    }
  }, {
    key: "initSwiper",
    value: function initSwiper() {
      var slider = this.querySelector('.breed-alphabet-filter__slider');
      this.navigationPrev = this.querySelector('.breed-alphabet-filter__nav-prev');
      this.navigationNext = this.querySelector('.breed-alphabet-filter__nav-next');
      if (!slider) return;
      this.swiper = new Swiper(slider, {
        slidesPerView: 7,
        slidesPerGroup: 7,
        spaceBetween: 0,
        allowTouchMove: true,
        speed: 300,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        breakpoints: {
          769: {
            slidesPerView: 20,
            slidesPerGroup: 20
          }
        },
        navigation: {
          nextEl: this.navigationNext,
          prevEl: this.navigationPrev
        }
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.paginationPrev) {
        this.paginationPrev.removeEventListener('click', this.onPaginationPrevClick);
      }
      if (this.paginationNext) {
        this.paginationNext.removeEventListener('click', this.onPaginationNextClick);
      }
      if (this.paginationNumbers) {
        this.paginationNumbers.removeEventListener('click', this.onPaginationNumbersClick);
      }
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('breed-alphabet-filter')) {
  customElements.define('breed-alphabet-filter', BreedAlphabetFilter);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/breed-alphabet-filter.js"));
/******/ }
]);